import React, { useRef, useEffect, useState } from 'react'
import { Carousel, Form, Button, Select, Popover, Avatar } from 'antd';
import { Link, useLocation } from 'react-router-dom'
import { LogoutOutlined } from '@ant-design/icons'
import styles from './index.module.scss'
import './index.scss'
import Login from '@/components/login/Login'
import { useDispatch } from 'react-redux'
import { fetchLogin } from '@/store/modules/user'
import { fetchMenuList } from '@/store/modules/permission'
import { getUserInfo as _getUserInfo, removeToken, removeUserInfo } from '@/utils/token'
import { getMenuList as _getMenuList, removeMenuList, removePathList, removeMenuPathList, removeButtonList } from '@/utils/menu'
import { checkLogin } from '@/utils'
import { getHouseTreeData2API, searchHouseAPI } from '@/apis/house'
import { getDataCountAPI } from '@/apis/common'
import * as echarts from 'echarts'

export default function Index() {
  const chartRef = useRef(null)
  const carouselRef = useRef(null)
  let myChart
  const [loginPopup, setLoginPopup] = useState(false)
  const [userInfo, setUserInfo] = useState(_getUserInfo() || {})
  const menuList = _getMenuList() || []
  const [dataCount, setDataCount] = useState({})
  const [carouselIndex, setCarouselIndex] = useState(0)
  const [searchHouseList, setSearchHouseList] = useState([
    {
      value: 334501106552909,
      text: '城投融创国博城'
    }
  ]) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    houseid: 334501106552909,
    num: 10
  })
  const [path, setPath] = useState('')

  const location = useLocation()
  const params = new URLSearchParams(location.search)

  const code = params.get('code')
  const state = params.get('state')

  const dispatch = useDispatch()
  const getLoginQrcode = () => {
    setLoginPopup(!loginPopup)
  }
  if (!userInfo.token) {
    const getUserInfo = async value => {
      let lastCode = localStorage.getItem('lastCode')
      if (value.code && value.code !== lastCode) {
        localStorage.setItem('lastCode', value.code)
        await dispatch(fetchLogin(value))
        const _userInfo = _getUserInfo()
        setUserInfo(_userInfo)
        if(_userInfo.token) {
          window.location.replace('/')
        }
      }
    }
    if (code) {
      getUserInfo({ code, state })
    }
  }
  //  楼盘树数据
  const searchFinish = async () => {
    myChart = echarts.init(chartRef.current)
    var option
    myChart.showLoading()
    const res = await getHouseTreeData2API(listQuery)
    if (res.success === true) {
      myChart.hideLoading()
      let data = {}
      if (res.result) {
        data.name = res.result.houseName
        data.id = res.result.houseId
        data.children = []
        if (res.result.relatedList) {
          res.result.relatedList.forEach(item => {
            let child = {
              id: item.houseId,
              name: item.houseName,
              data: Math.round((item.viewNum / res.result.viewNum) * 100) + '%',
              collapsed: true
            }
            let gap = item.salePrice - res.result.salePrice
            if (gap <= 500 && gap >= -500) {
              child.gap = '同价位'
            }
            if (item.plateId == res.result.plateId) {
              child.plateType = '同板块'
            } else if (item.districtId == res.result.districtId) {
              child.plateType = '同区域'
            }
            data.children.push(child)
          })

          myChart.setOption(
            (option = {
              tooltip: {
                show: false
              },
              series: [
                {
                  type: 'tree',
                  data: [data],
                  top: '1%',
                  left: '180px',
                  bottom: '1%',
                  right: '300px',
                  symbolSize: 7,
                  itemStyle: {
                    color: '#07C160'
                  },
                  expandLevel: 1,
                  label: {
                    position: 'left',
                    verticalAlign: 'middle',
                    align: 'right',
                    color: '#262626',
                    fontSize: 18,
                    lineHeight: 48,
                    overflow: 'break',
                    with: 100,
                    formatter: function (value) {
                      if (value.data.data) {
                        if (value.data.gap) {
                          if (value.data.plateType) {
                            return `{rate|${value.data.data}} {name|${value.data.name}} {gap|${value.data.gap}} {plateType|${value.data.plateType}}`
                          } else {
                            return `{rate|${value.data.data}} {name|${value.data.name}} {gap|${value.data.gap}}`
                          }
                        } else {
                          if (value.data.plateType) {
                            return `{rate|${value.data.data}} {name|${value.data.name}} {plateType|${value.data.plateType}}`
                          } else {
                            return `{rate|${value.data.data}} {name|${value.data.name}}`
                          }
                        }
                      } else {
                        if (value.data.gap) {
                          if (value.data.plateType) {
                            return `{name|${value.data.name}} {gap|${value.data.gap}} {plateType|${value.data.plateType}}`
                          } else {
                            return `{name|${value.data.name}} {gap|${value.data.gap}}`
                          }
                        } else {
                          if (value.data.plateType) {
                            return `{name|${value.data.name}} {plateType|${value.data.plateType}}`
                          } else {
                            return `{name|${value.data.name}}`
                          }
                        }
                      }
                    },
                    rich: {
                      rate: {
                        backgroundColor: '#E6F8EF',
                        color: '#07C160',
                        padding: [5, 5],
                        borderRadius: 4,
                        fontSize: 18
                      },
                      name: {
                        color: '#262626',
                        fontSize: 18
                      },
                      gap: {
                        backgroundColor: '#F2F2F2',
                        color: '#666666',
                        padding: [5, 5],
                        borderRadius: 4,
                        fontSize: 14
                      },
                      plateType: {
                        backgroundColor: '#F2F2F2',
                        color: '#666666',
                        padding: [5, 5],
                        borderRadius: 4,
                        fontSize: 14
                      }
                    }
                  },
                  lineStyle: {
                    color: '#999999',
                    width: 1
                  },
                  leaves: {
                    label: {
                      position: 'left',
                      verticalAlign: 'middle',
                      align: 'left',
                      lineHeight: 48
                    }
                  },
                  selectedMode: 'single',
                  expandAndCollapse: true,
                  animationDuration: 550,
                  animationDurationUpdate: 750
                }
              ]
            })
          )
          option && myChart.setOption(option)
        }
      }
    }
  }
  const getDataCount = async () => {
    const res = await getDataCountAPI()
    if (res.success === true) {
      setDataCount(res.result)
    }
  }
  const changeCarousel = (index) => {
    setCarouselIndex(index)
  }
  //  点击走马灯
  const clickCarousel = (index) => {
    setCarouselIndex(index)
    carouselRef.current.goTo(index);
  }

  let timeout
  let currentValue
  const fetch = (value, callback) => {
    if (timeout) {
      clearTimeout(timeout)
      timeout = null
    }
    currentValue = value
    const fake = async () => {
      const res = await searchHouseAPI({ keywords: value })
      if (res.success === true) {
        if (currentValue === value) {
          const searchHouseList = res.result.map(item => ({
            value: item.id,
            text: item.name
          }))
          callback(searchHouseList)
        }
      }
    }
    if (value) {
      timeout = setTimeout(fake, 300)
    } else {
      callback([])
    }
  }
  const handleSearch = newValue => {
    fetch(newValue, setSearchHouseList)
  }
  const handleChange = newValue => {
    setListQuery({
      ...listQuery,
      houseid: newValue
    })
  }
  const loginOut = () => {
    removeToken()
    removeUserInfo()
    removeMenuList()
    removePathList()
    removeMenuPathList()
    removeButtonList()
    window.location.replace('/')
  }
  useEffect(() => {
    getDataCount()
    searchFinish()
    if(userInfo.token) {
      if(!checkLogin()) {
        setTimeout(() => {
          window.location.replace('/')
        }, 2000)
      }
      if(menuList.length < 1) {
        dispatch(fetchMenuList())
      }
    }
    setPath(menuList[0]?.children[0]?.key || '/managecenter/housetree')
  }, [])

  return (
    <div className="bg-f5f6f9">
      <div className={['bg-white', styles['top']].join(' ')}>
        <div className={['flex-between', 'height-100', 'margin-auto', styles['main']].join(' ')}>
          <img src="/images/logo.png" className={styles['logo']} />
          {userInfo?.token ? (
            <div className={['flex-center', 'height-100'].join(' ')}>
              {/* <div className="nav-item cur">工作台</div> */}
              <Link target="_blank" className="black" to={userInfo?.isPhone ? path : "/bind"}>
                <div className={['padding-left-20', 'padding-right-20', 'height-100', 'flex', 'align-items', 'cursor-pointer'].join(' ')}>工作台</div>
              </Link>
              <Popover placement="bottom" content={
                <div className={['flex', 'align-items',  'margin-right-16', 'margin-left-16', 'cursor-pointer'].join(' ')} onClick={loginOut}>
                  <LogoutOutlined />
                  <div className='margin-left-10'>退出登录</div>
                </div>
              }>
                <div className={['padding-left-20', 'padding-right-20', 'height-100', 'flex', 'align-items', 'cursor-pointer', 'hover-bg-f1f1f1'].join(' ')}>
                  <Avatar shape='circle' size={40} src={userInfo?.avatar} draggable={false}></Avatar>
                </div>
              </Popover>
            </div>
          ) : (
            <div className={['flex-center', 'height-100'].join(' ')}>
              <div className={['padding-left-20', 'padding-right-20', 'height-100', 'flex', 'align-items', 'cursor-pointer', 'hover-bg-f1f1f1'].join(' ')} onClick={getLoginQrcode}>工作台</div>
              <div className={['padding-left-20', 'padding-right-20', 'height-100', 'flex', 'align-items', 'cursor-pointer', 'hover-bg-f1f1f1'].join(' ')} onClick={getLoginQrcode}>登录</div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-green">
        <div className={[styles['main'], 'margin-auto', 'position-relative'].join(' ')}>
          <img src="/images/banner.png" className="width-100" />
          <div className="position-absolute">
            <div className={['white', 'width-100', 'margin-auto', styles['banner']].join(' ')}>
              <div className={['font-size48', 'font-weight-600', 'banner-tit'].join(' ')}>房产数据与技术服务商</div>
              <div className={['font-size48', 'font-weight-600', 'banner-tit'].join(' ')}>为房产行业赋能！</div>
              <div className="banner-desc">
                <div>立足武汉，面向全国</div>
                <div>拥抱AI，聚焦产业互联网</div>
              </div>
              {userInfo?.token ? (
                <Link target="_blank" className="black" to={userInfo?.isPhone ? path : "/bind"}>
                  <div className="banner-btn">申请试用</div>
                </Link>
              ) : (
                <div className="banner-btn" onClick={getLoginQrcode}>申请试用</div>
              )}
            </div>
          </div>
          <div className={[styles['datainfo-title'], 'white', 'flex', 'font-size18', 'align-center'].join(' ')}>
            <div className={[styles['datainfo-title-left'], 'bg-06ae56', 'position-relative'].join(' ')}></div>
            <div className={[styles['datainfo-title-txt'], 'bg-06ae56', 'position-relative'].join(' ')}>武房通实时数据资产</div>
            <div className={[styles['datainfo-title-right'], 'bg-06ae56', 'position-relative'].join(' ')}></div>
          </div>
        </div>
      </div>
      <div className="datainfo">
        <div className={['datainfo-list', styles['main']].join(' ')}>
          <div className="datainfo-item">
            <div className="datainfo-num">{ dataCount.houseTotal }</div>
            <div className="datainfo-txt">楼盘</div>
          </div>
          <div className="datainfo-item">
            <div className="datainfo-num">{ dataCount.saleHouseNum }</div>
            <div className="datainfo-txt">在售楼盘</div>
          </div>
          <div className="datainfo-item">
            <div className="datainfo-num">{ dataCount.projectTotal }</div>
            <div className="datainfo-txt">项目地块</div>
          </div>
          <div className="datainfo-item">
            <div className="datainfo-num">{ dataCount.buildTotal }</div>
            <div className="datainfo-txt">楼栋</div>
          </div>
          <div className="datainfo-item">
            <div className="datainfo-num">{ dataCount.roomTotal }</div>
            <div className="datainfo-txt">房源</div>
          </div>
          <div className="datainfo-item">
            <div className="datainfo-num">{ dataCount.evidenceTotal }</div>
            <div className="datainfo-txt">预售证</div>
          </div>
          <div className="datainfo-item">
            <div className="datainfo-num">{ dataCount.completionTotal }</div>
            <div className="datainfo-txt">竣工信息</div>
          </div>
          <div className="datainfo-item">
            <div className="datainfo-num">{ dataCount.developersTotal }</div>
            <div className="datainfo-txt">开发商</div>
          </div>
        </div>
      </div>
      <div className='padding-top-80 bg-white'>
        <div className={[styles['main'], 'margin-left-auto', 'margin-right-auto'].join(' ')}>
          <div className={styles['title']}>好客通</div>
          <div className='margin-top-16 line-height-30 font-size20 align-center gray'>透明化，真客资！量贩式，自取自用</div>
          <div className='margin-top-60 flex-center'>
            <div className={[styles['cule-item'], (carouselIndex == 0 ? 'bg-e6f8ef' : 'bg-f5f6f9'), 'border-radius-4'].join(' ')} onClick={() => clickCarousel(0)}>
              <div className='font-weight-600 line-height-32 margin-bottom-24 font-size24'>精准客资</div>
              <div className='font-size16 line-height-30 gray'>历经3年口碑传播</div>
              <div className='font-size16 line-height-30 gray'>海量精准用户</div>
            </div>
            <div className={[styles['cule-item'], (carouselIndex == 1 ? 'bg-e6f8ef' : 'bg-f5f6f9'), 'border-radius-4'].join(' ')} onClick={() => clickCarousel(1)}>
              <div className='font-weight-600 line-height-32 margin-bottom-24 font-size24'>自取自用</div>
              <div className='font-size16 line-height-30 gray'>量贩式，自取自用</div>
              <div className='font-size16 line-height-30 gray'>按需开放竞品客资</div>
            </div>
            <div className={[styles['cule-item'], (carouselIndex == 2 ? 'bg-e6f8ef' : 'bg-f5f6f9'), 'border-radius-4'].join(' ')} onClick={() => clickCarousel(2)}>
              <div className='font-weight-600 line-height-32 margin-bottom-24 font-size24'>用户画像</div>
              <div className='font-size16 line-height-30 gray'>大数据，多维度用户画像</div>
              <div className='font-size16 line-height-30 gray'>更好洞察用户</div>
            </div>
            <div className={[styles['cule-item'], (carouselIndex == 3 ? 'bg-e6f8ef' : 'bg-f5f6f9'), 'border-radius-4'].join(' ')} onClick={() => clickCarousel(3)}>
              <div className='font-weight-600 line-height-32 margin-bottom-24 font-size24'>多端联动</div>
              <div className='font-size16 line-height-30 gray'>选客、分客、跟进客资</div>
              <div className='font-size16 line-height-30 gray'>透明、高效、多端联动</div>
            </div>
          </div>
          <Carousel autoplay dots={false}  ref={carouselRef} draggable afterChange={changeCarousel}>
            <div className='margin-top-24 width-100'>
              <img src="/images/1.png" className='img' />
            </div>
            <div className='margin-top-24 width-100'>
              <img src="/images/2.png" className='img' />
            </div>
            <div className='margin-top-24 width-100'>
              <img src="/images/3.png" className='img' />
            </div>
            <div className='margin-top-24 width-100'>
              <img src="/images/4.png" className='img' />
            </div>
          </Carousel>
          
        </div>
      </div>
      <div className={[styles['main'], 'margin-left-auto', 'margin-right-auto'].join(' ')}>
        <div className={[styles['title'], 'padding-top-80'].join(' ')}>榜单定制</div>
        <div className='margin-top-16 line-height-30 font-size20 align-center gray'>4大权威榜单，区域、时间、价格多维度定制</div>
        <div className='margin-top-60 flex-center'>
          <div className={[styles['width-252'], 'margin-right-24'].join(' ')}>
            <img src="/images/5.png" className='img' />
          </div>
          <div className={[styles['width-252'], 'margin-right-24'].join(' ')}>
            <img src="/images/6.png" className='img' />
          </div>
          <div className={[styles['width-252'], 'margin-right-24'].join(' ')}>
            <img src="/images/7.png" className='img' />
          </div>
          <div className={[styles['width-252'], 'margin-right-24'].join(' ')}>
            <img src="/images/8.png" className='img' />
          </div>
        </div>
      </div>
      <div className='bg-white'>
        <div className={[styles['main'], 'margin-left-auto', 'margin-right-auto'].join(' ')}>
          <div className={[styles['title'], 'padding-top-80'].join(' ')}>竞品发掘</div>
          <div className='margin-top-16 line-height-30 font-size20 align-center gray'>大数据，让你更懂竞品</div>
          <Form initialValues={listQuery} onFinish={searchFinish} className='flex-center margin-auto margin-top-60 margin-bottom-60'>
            <Form.Item name="houseid">
              <Select
                allowClear
                showSearch
                style={{fontSize: '18px'}}
                variant='borderless'
                placeholder="输入楼盘...查竞品"
                className={styles['select']}
                defaultActiveFirstOption={true}
                suffixIcon={null}
                filterOption={false}
                onSearch={handleSearch}
                onChange={handleChange}
                notFoundContent={null}
                options={(searchHouseList || []).map(d => ({
                  value: d.value,
                  label: d.text
                }))}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" className={styles['btn']} htmlType="submit" style={{ marginLeft: '10px' }}>
                查询
              </Button>
            </Form.Item>
          </Form>
          <div className={styles['house-box']}>
            <div ref={chartRef} style={{ width: '100%', height: '100%', margin: '0 auto' }} />
          </div>
        </div>
      </div>
      <div className='padding-top-80'>
        <div className={['margin-auto', styles['main']].join(' ')}>
          <div className={styles['title']}>更多功能</div>
          <div className='margin-top-16 line-height-30 font-size20 align-center gray'>为销售、策划、产品设计、产品定价、战略决策全面赋能</div>
          <div className={styles['more-action-list']}>
            <div className={styles['more-action-item']}>
              <div className={styles['more-action-icon']}>
                <img src="/images/9.png" className='img' />
              </div>
              <div className={styles['more-action-title']}>武房数据库</div>
              <div className={styles['more-action-txt']}>楼盘、预售证、一房一价</div>
              <div className={styles['more-action-txt']}>项目地块、开发商、品牌</div>
            </div>
            <div className={styles['more-action-item']}>
              <div className={styles['more-action-icon']}>
                <img src="/images/10.png" className='img' />
              </div>
              <div className={styles['more-action-title']}>全市供销存</div>
              <div className={styles['more-action-txt']}>全市、15大区、60+板块</div>
              <div className={styles['more-action-txt']}>供销存大数据</div>
            </div>
            <div className={styles['more-action-item']}>
              <div className={styles['more-action-icon']}>
                <img src="/images/11.png" className='img' />
              </div>
              <div className={styles['more-action-title']}>数据大屏</div>
              <div className={styles['more-action-txt']}>房产数据大屏</div>
              <div className={styles['more-action-txt']}>赋能营销，按需定制</div>
            </div>
            <div className={styles['more-action-item']}>
              <div className={styles['more-action-icon']}>
                <img src="/images/12.png" className='img' />
              </div>
              <div className={styles['more-action-title']}>行业报告</div>
              <div className={styles['more-action-txt']}>购房者报告、市场报告</div>
              <div className={styles['more-action-txt']}>赋能策划，赋能决策</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles['try-used']}>
        <div className='line-height-64 font-size48'>领先一步，领先一路</div>
        {userInfo?.token ? (
          <Link target="_blank" className="white" to={userInfo?.isPhone ? path : "/bind"}>
            <div className={[styles['try-used-btn'], 'line-height-64', 'font-size24', 'margin-top-40', 'margin-auto'].join(' ')}>申请试用</div>
          </Link>
        ) : (
          <div className={[styles['try-used-btn'], 'line-height-64', 'font-size24', 'margin-top-40', 'margin-auto'].join(' ')} onClick={getLoginQrcode}>申请试用</div>
        )}
      </div>
      <div className='bg-white'>
        <div className={[styles['main'], 'margin-left-auto', 'margin-right-auto'].join(' ')}>
          <div className='padding-top-110 padding-bottom-60 flex align-items'>
            <div className='flex-1 flex-col align-items font-size24'>
              <img src="/images/13.png" className='margin-bottom-12' style={{width: '160px'}} />
              客服
            </div>
            <div className='flex-1 flex-col align-items font-size24'>
              <img src="/images/14.png" className='margin-bottom-12' style={{width: '160px'}} />
              订阅号
            </div>
            <div className='flex-1 flex-col align-items font-size24'>
              <img src="/images/15.png" className='margin-bottom-12' style={{width: '160px'}} />
              服务号
            </div>
            <div className='flex-1 flex-col align-items font-size24'>
              <img src="/images/16.png" className='margin-bottom-12' style={{width: '160px'}} />
              小程序
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noreferrer">
          Copyright © 2023 武房通 鄂ICP备19026447号
        </a>
      </div>
      {loginPopup ? <Login loginPopup={loginPopup} onLoginPopup={getLoginQrcode} /> : ''}
    </div>
  )
}
